import i18n from '@/plugins/i18n.js';
import { router } from '@/routes/index.js';
import pinia from '@/stores/index.js';

import 'virtual:svg-icons-register';

import '@/plugins/validate.js';
import '@/routes/middleware';

import VueVirtualScroller from 'vue-virtual-scroller';

const plugins = [
  { app: i18n, option: {} },
  { app: pinia, option: {} },
  { app: router, option: {} },
  { app: VueVirtualScroller, option: {} }
];

export default plugins;
